import { Typography } from 'antd'
import styled from 'styled-components'

export const AppVersionStyled: typeof Typography.Text = styled(Typography.Text)`
  & {
    color: white;
  }
`
